import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-overall-sentiment-meh-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfOverallSentimentMehIconProps extends SvgIconProps {}

/**
 * Component to render overall sentiment icon for intermediate score in RTIG
 * @param props - CcfOverallSentimentMehIconProps
 * @example <CcfOverallSentimentMehIcon />
 * @returns
 */
export function CcfOverallSentimentMehIcon(
  props: CcfOverallSentimentMehIconProps
) {
  return (
    <SvgIcon
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8ZM1.6 8C1.6 11.52 4.48 14.4 8 14.4C11.52 14.4 14.4 11.52 14.4 8C14.4 4.48 11.52 1.6 8 1.6C4.48 1.6 1.6 4.48 1.6 8ZM5.6 11.2C5.12 11.2 4.8 10.88 4.8 10.4C4.8 9.92 5.12 9.6 5.6 9.6H10.4C10.88 9.6 11.2 9.92 11.2 10.4C11.2 10.88 10.88 11.2 10.4 11.2H5.6ZM8.8 5.76C8.8 4.88 9.52 4.16 10.4 4.16C11.28 4.16 12 4.88 12 5.76C12 6.64 11.28 7.36 10.4 7.36C9.52 7.36 8.8 6.64 8.8 5.76ZM4 5.76C4 4.88 4.72 4.16 5.6 4.16C6.48 4.16 7.2 4.88 7.2 5.76C7.2 6.64 6.48 7.36 5.6 7.36C4.72 7.36 4 6.64 4 5.76Z"
        fill="#916100"
      />
    </SvgIcon>
  );
}

export default CcfOverallSentimentMehIcon;
